import {
	SET_ITEMS,
	SET_ITEMS_AAXML,
	SELECT_ANSWER,
	SELECT_TEST_ANSWER,
	GO_TO_PREVIOUS_ITEM,
	GO_TO_NEXT_ITEM,
	GO_TO_ITEM,
	RECOVER_SAVED_STATE,
	SHOW_RESULTS,
	RESTART_EXERCISE,
	SET_CORRECT_ANSWERS,
	START_RECORDING,
	STOP_RECORDING,
	SET_AUTO_NUM,
	SET_RANDOM_ITEMS,
	SET_RANDOM_ITEMS_ORDER,
	SET_EXERCISE_READY,
	SET_ITEMS_TO_SHOW
} from '../actions/types';

// Return object from function to avoid data sharing between instances
const INITIAL_STATE = () => ({
	items: [],
	itemsAAXML: [],
	currentItem: 0,
	itemsAttempted: [],
	answersMarked: [],
	answersSelected: [],
	correctAnswers: [],
	resultsVisible: false,
	totalCorrectAnswers: 0,
	recording: false,
	autoNum: false,
	randomItems: false,
	randomItemsOrder: null,
	exerciseReady: false,
	itemsToShow: undefined
});

export default function (state = INITIAL_STATE(), action) {
	switch (action.type) {
		case SET_RANDOM_ITEMS: {
			const newState = { ...state };
			newState.randomItems = action.payload;
			return newState;
		}

		case SET_ITEMS_TO_SHOW: {
			const newState = { ...state };
			newState.itemsToShow = action.payload || undefined;
			return newState;
		}

		case SET_EXERCISE_READY: {
			const newState = { ...state };
			newState.exerciseReady = true;
			return newState;
		}

		case SET_ITEMS: {
			const newState = { ...state };
			newState.items = action.payload;
			return newState;
		}

		case SET_ITEMS_AAXML: {
			const newState = { ...state };
			newState.itemsAAXML = action.payload;
			return newState;
		}

		case SELECT_ANSWER: {
			const newState = { ...state };
			const { answersMarked, answersSelected, itemsAttempted } = newState;
			const { fromItem, answerSelected } = action.payload;

			answersMarked[fromItem] = answersMarked[fromItem] ? [...answersMarked[fromItem]] : [];
			answersMarked[fromItem][action.payload] = true;

			answersSelected[fromItem] = answerSelected;
			itemsAttempted[fromItem] = true;
			// console.group('exercise', action.type);
			// console.log(action.payload);
			// console.log('state.answersMarked', state.answersMarked);
			// console.log('newState.answersMarked', newState.answersMarked);
			// console.groupEnd();

			return newState;
		}

		case SELECT_TEST_ANSWER: {
			const newState = { ...state };
			const { answersSelected, itemsAttempted, currentItem } = newState;
			answersSelected[currentItem] = action.payload;
			itemsAttempted[currentItem] = true;
			return newState;
		}

		case GO_TO_PREVIOUS_ITEM: {
			const newState = { ...state };
			if (newState.resultsVisible) {
				newState.resultsVisible = false;
				newState.currentItem = newState.items.length - 1;
			} else {
				newState.currentItem--;
			}
			return newState;
		}

		case GO_TO_NEXT_ITEM: {
			const newState = { ...state };
			newState.currentItem++;
			return newState;
		}

		case GO_TO_ITEM: {
			const newState = { ...state };
			newState.currentItem = action.payload;
			newState.resultsVisible = false;
			return newState;
		}

		case SHOW_RESULTS: {
			const newState = { ...state };
			newState.resultsVisible = true;
			newState.currentItem = null;
			return newState;
		}

		case RECOVER_SAVED_STATE: {
			const newState = { ...state };
			newState.currentItem = action.payload.currentItem;
			newState.itemsAttempted = action.payload.itemsAttempted;
			newState.answersSelected = action.payload.answersSelected;
			newState.answersMarked = action.payload.answersMarked;
			newState.correctAnswers = action.payload.correctAnswers;
			newState.resultsVisible = action.payload.resultsVisible;
			newState.totalCorrectAnswers = action.payload.totalCorrectAnswers;
			newState.itemsToShow = action.payload.itemsToShow;
			newState.randomItemsOrder = action.payload.randomItemsOrder;
			return newState;
		}

		case RESTART_EXERCISE: {
			return {
				...INITIAL_STATE(),
				itemsAAXML: state.itemsAAXML,
				items: state.items,
				itemsAttempted: [],
				answersMarked: [],
				answersSelected: [],
				correctAnswers: [],
				exerciseReady: true,
				itemsToShow: state.itemsToShow,
				randomItems: state.randomItems,
				randomItemsOrder: state.randomItemsOrder,
				autoNum: state.autoNum
			};
		}

		case SET_CORRECT_ANSWERS: {
			const newState = { ...state };
			newState.totalCorrectAnswers = action.payload.total;
			newState.correctAnswers = action.payload.correctAnswers;
			return newState;
		}

		case START_RECORDING: {
			const newState = { ...state };
			newState.recording = true;
			return newState;
		}

		case STOP_RECORDING: {
			const newState = { ...state };
			newState.recording = false;
			return newState;
		}

		case SET_AUTO_NUM: {
			const newState = { ...state };
			newState.autoNum = action.payload;
			return newState;
		}

		case SET_RANDOM_ITEMS_ORDER: {
			const newState = { ...state };
			newState.randomItemsOrder = action.payload;
			return newState;
		}

		default:
			return state;
	}
}
